import feathersClient, { makeServicePlugin, BaseModel } from '../../feathers-client'

class CompassFolder extends BaseModel {
  // Required for $FeathersVuex plugin to work after production transpile.

  static modelName = 'CompassFolder'
  // Define default properties here
  static instanceDefaults () {
    return {
      title: '',
      userId: null,
    }
  }
}
const servicePath = 'compass-folder'
const servicePlugin = makeServicePlugin({
  Model: CompassFolder,
  service: feathersClient.service(servicePath),
  servicePath,
})

// Setup the client-side Feathers hooks.
feathersClient.service(servicePath).hooks({
  before: {
    all: [],
    find: [],
    get: [],
    create: [
      () => {
        console.log('created folder!')
      },
    ],
    update: [],
    patch: [],
    remove: [],
  },
  after: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },
  error: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },
})

export default servicePlugin
